import React, { FC, ReactElement } from 'react'
import { Box, Container, Grid, Typography } from '@mui/material'

export const CommonTipItem: FC<{
  value: string | ReactElement
  iconComponent: ReactElement<HTMLElement, string> | null
  valueBold?: string
  valueWordUnderline?: string
  title?: string
}> = ({ value, title, iconComponent, valueBold, valueWordUnderline, ...rest }) => {
  return (
    <Box py={3} px={0} className="tipItem" {...rest}>
      <Container component="div" maxWidth={false} disableGutters={true}>
        <Grid
          container
          className="alertHeader"
          sx={{
            margin: '5px 0px 5px 0px',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            flexWrap: 'nowrap',
          }}
        >
          <Grid mr={iconComponent ? 2 : 0}>{iconComponent}</Grid>
          <Grid width="100%">
            {!!title && <Typography fontWeight="bold">{title}</Typography>}
            {!!valueBold && (
              <Typography fontWeight="bold" m={0} data-test="tipBold">
                {valueBold}
              </Typography>
            )}
            <Box display="flex" flexWrap="wrap" data-test="tip">
              <Typography component={'span'}>
                {value}
                {!!valueWordUnderline && (
                  <b>
                    &nbsp;
                    <u>{valueWordUnderline}</u>
                  </b>
                )}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}
